<template>
    <select
        v-bind="$attrs"
        :class="['custom-select', size && `custom-select-${size}`]"
        :value="currentValue"
        :disabled="disabled"
        @change="update($event)"
    >
        <slot name="first" />
        <option
            v-for="(option, index) in normalizedOptions"
            :key="index"
            :value="option.value"
            :disabled="option.disabled"
        >{{ option.text }}</option>
        <slot />
    </select>
</template>
<script>
import { emitModel } from "./model";
export default {
    name: "SbFormSelect",
    emits: ["update:modelValue", "change"],
    inheritAttrs: false,
    props: {
        modelValue: { default: undefined },
        options: { type: Array, default: () => [] },
        valueField: { type: String, default: "value" },
        textField: { type: String, default: "text" },
        disabledField: { type: String, default: "disabled" },
        size: { type: String, default: null },
        disabled: { type: Boolean, default: false },
    },
    computed: {
        currentValue() { return this.modelValue; },
        normalizedOptions() {
            return this.options.map((option) => typeof option === "object"
                ? { value: option[this.valueField], text: option[this.textField], disabled: option[this.disabledField] }
                : { value: option, text: option, disabled: false });
        },
    },
    methods: {
        update(event) {
            const selectedOption = event.target.options[event.target.selectedIndex];
            const value = event.target.value;
            const match = this.normalizedOptions.find((option) => String(option.value) === value);
            const hasTypedValue = selectedOption && Object.prototype.hasOwnProperty.call(selectedOption, "_value");
            const selectedNullOption = Array.from(event.target.options)
                .some((option) => option.dataset.sbNull === "true" && value === "");
            const resolved = selectedNullOption
                ? null
                : (match ? match.value : (hasTypedValue ? selectedOption._value : value));
            emitModel(this, resolved);
            this.$emit("change", resolved);
        },
    },
};
</script>
